import { Component, OnDestroy, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AlertManagementService } from '../../alert-management.service';
import { Alert, AlertConfiguration } from '../../alert';
import { DataManagementService } from '../../../data-management/data-management.service';
import { Subscription } from 'rxjs';
import { AlertManagementServiceUtils } from '../../alert-management-utils.service';

interface HourOption {
  value: number;
  label: string;
}

@Component({
  selector: 'app-speed-carto-settings',
  templateUrl: './speed-carto-settings.component.html',
  styleUrls: ['./speed-carto-settings.component.css']
})
export class SpeedCartoSettingsComponent implements OnInit, OnDestroy {
  public checked = true;
  public showAdvancedSettings = false;
  public loader = false;
  public hours: HourOption[] = [];
  public minutes: { value: number; label: string }[] = [];
  public enableGlobalConfig = false;
  public enableGlobalConfigToAllVehicules = false;

  public alert: Alert = new Alert();

  public speedAlertConfiguration: AlertConfiguration = new AlertConfiguration();
  public cronAlertConfiguration: AlertConfiguration = new AlertConfiguration();

  public isResultLoaded = true;

  public getVehiculeWasSelectedSubscription: Subscription;

  constructor(
    private toastr: ToastrService,
    private alertManagementService: AlertManagementService,
    private dataManagementService: DataManagementService,
    private alertManagementServiceUtils: AlertManagementServiceUtils
  ) {
    this.initHours();
    this.initMinutes();
  }

  ngOnInit() {
    if (this.dataManagementService.selectedVehicule) {
      this.loadAlertConfigOfDevice(
        this.dataManagementService.selectedVehicule.idDevice
      );
    }

    this.getVehiculeWasSelectedSubscription = this.dataManagementService
      .getVehiculeWasSelected()
      .subscribe(vehicule => {
        this.loadAlertConfigOfDevice(
          (this.dataManagementService.selectedVehicule as any).idDevice
        );
      });

  }

  ngOnDestroy() {
    if (this.getVehiculeWasSelectedSubscription) {
      this.getVehiculeWasSelectedSubscription.unsubscribe();
    }
  }

  loadAlertConfigOfDevice(device: number) {
    this.loader = true;
    this.speedAlertConfiguration = new AlertConfiguration();
    this.cronAlertConfiguration = new AlertConfiguration();

    this.alertManagementService
      .getAlertByNameAndDeviceId('SPEED_CARTO', device)
      .subscribe(
        alert => {
          if (!alert) {
            // ✅ Alerte vide prête à être modifiée et sauvegardée
            this.alert = new Alert();
            this.alert.id = null;            // null = INSERT côté backend
            this.alert.deviceId = device;
            this.alert.name = 'SPEED_CARTO';
            this.alert.isActive = false;
            this.alert.emailMode = false;
            this.alert.emails = '';
            this.alert.alertConfigurations = [];
            this.loader = false;
            this.toastr.warning('Aucune configuration, vous pouvez en créer une', 'info !', { timeOut: 2000 });
            return;
          }

          this.alert = alert;

          if (this.alert.alertConfigurations?.length > 0) {
            const dateConfig = this.alert.alertConfigurations.filter(ac => ac.type === 'DATE');
            this.cronAlertConfiguration = dateConfig.length > 0 ? dateConfig[0] : this.cronAlertConfiguration;

            const speedConfig = this.alert.alertConfigurations.filter(ac => ac.type === 'SPEED_CARTO');
            this.speedAlertConfiguration = speedConfig.length > 0 ? speedConfig[0] : this.speedAlertConfiguration;

            if (this.speedAlertConfiguration == null) {
              this.alertManagementServiceUtils.initializeAlertConfiguration('SPEED_CARTO');
            }
          }

          this.loader = false;
          this.toastr.success('Configuration chargée', 'info !', { timeOut: 1000 });
        },
        () => {
          this.loader = false;
          this.toastr.error('Configuration non chargée', 'info !', { timeOut: 1000 });
        }
      );
  }

  collapseAdvancedSettings() {
    this.showAdvancedSettings = !this.showAdvancedSettings;
  }

  initHours() {
    for (let i = 0; i <= 24; i++) {
      this.hours.push({ value: i, label: i > 9 ? i.toString() : '0' + i });
    }
  }


  initMinutes() {
    for (let i = 0; i < 4; i++) {
      this.minutes.push({
        value: i,
        label: i > 0 ? (i * 15).toString() : '0' + i
      });
    }
  }
  save() {
    this.loader = true;
    this.alert.enableGlobalConfig = this.enableGlobalConfig;

    // ✅ Lier speedAlertConfiguration à l'alert avant de sauvegarder
    if (this.speedAlertConfiguration && this.speedAlertConfiguration.value1) {
      const existingIndex = this.alert.alertConfigurations.findIndex(
        ac => ac.type === 'SPEED_CARTO'
      );
      if (existingIndex >= 0) {
        // UPDATE : remplacer l'existante
        this.alert.alertConfigurations[existingIndex] = this.speedAlertConfiguration;
      } else {
        // INSERT : ajouter la nouvelle config
        this.speedAlertConfiguration.type = 'SPEED_CARTO';
        this.alert.alertConfigurations.push(this.speedAlertConfiguration);
      }
    }

    this.alertManagementService.updateAlert(this.alert).subscribe(
      alert => {
        this.alert = alert;  // ✅ backend retourne l'alert avec son nouvel id
        this.toastr.success('Configuration enregistrée', 'info !');
        this.loader = false;
      },
      error => {
        this.toastr.error('Configuration non enregistrée', 'info !');  // ✅ error pas success
        this.loader = false;
      }
    );
  }

  emailSettings(emailsSettings: { emailMode: boolean; emails: string; enableGlobalConfig: boolean, enableGlobalConfigToAllVehicules: boolean  }) {
    this.alert.emailMode = emailsSettings.emailMode;
    this.alert.emails = emailsSettings.emails;
    this.enableGlobalConfig = emailsSettings.enableGlobalConfig;
    this.enableGlobalConfigToAllVehicules = emailsSettings.enableGlobalConfigToAllVehicules;
    if (emailsSettings.enableGlobalConfig || emailsSettings.enableGlobalConfigToAllVehicules) {
      this.updateEmails();
    }
  }

  updateEmails() {
    let id = 0;
    if (this.enableGlobalConfig || this.enableGlobalConfigToAllVehicules) {
      id = this.alert.deviceId;
    } else {
      id = this.alert.id;
    }
    this.alertManagementService.setEmailToAllAlert(this.alert.emails, id, this.enableGlobalConfig, this.enableGlobalConfigToAllVehicules)
      .subscribe(res => {
          if (res) {
            this.toastr.success('emails bien copiés ');
          } else {
            this.toastr.warning('Veuillez reverifier');
          }
        }
      )
  }

}
